import { json } from '../../../app/utils';
import { API_URL } from '../utils';
import get from 'lodash/get';
// import { debug } from '../../../utils';
// const log = debug('lego:api/Profile/fetch');

const transformFromOldFunction = (fn) => ({
		id: fn['function'],
		note: fn.note,
		severity: fn.severity
});

const transformFromOldAT = (AT) => AT;
import keyBy from 'lodash/keyBy'
// TODO: Move 'credentials', 'employer', 'trained_rater', 'specialty' to account
// TODO: 'gender' -> 'sex'
const transformFromOldProfile = ({
    id, name, zipcode, describes, describes_other, gender, birth_year, diagnosis, leaves_house,
    functions, functions_other, assistive_tech, assistive_tech_other, completion
}) => ({
		id, name, zipcode,
		describes: get(describes, 0, undefined), describes_other,
		gender: get(gender, 0, undefined),
		birth_year, diagnosis, leaves_house,
	functions: keyBy((functions || []).map(transformFromOldFunction), 'id'),
		functions_other,
		assistive_tech: (assistive_tech || []).map(transformFromOldAT),
		assistive_tech_other, completion
});

import { apiRequest } from '../utils'
const fetch = (payload, stateOrRequest) =>
	apiRequest('profiles/', undefined, 'GET', stateOrRequest)
	.map(({profiles}) => transformFromOldProfile(profiles[0]))
	.catch((e => console.log('Transformer error:', e)) as any)

export default fetch;



// WEBPACK FOOTER //
// ./src/server/api/Profile/fetch.ts